export function getLayoutPrimaryColor() {
  return '#087dff'
}

export function getLayoutPrimaryRgba(alpha = 1) {
  return `rgba(8, 125, 255, ${Math.max(0, Math.min(1, Number(alpha) || 0))})`
}
